module.exports = __webpack_public_path__ + "static/img/2.fe7bc7f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/8/eng/2.png
// module id = UZTp
// module chunks = 0